const initialState = {
  selected: {},
  preparations: []
}

const preparations = (state = initialState, action) => {
  switch (action.type) {
    case 'ADD_PREPARATIONS':
      return Object.assign({}, state, {
        preparations: action.preparations
      })
    case 'SELECT_PREPARATION':
      return Object.assign({}, state, {
        selected: action.preparation
      })
    case 'REMOVE_PREPARATIONS':
      return Object.assign({}, state, {
        preparations: [],
        selected:{}
      })
    default:
      return state
  }
}

export default preparations;
